import React, { useState } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";
import headerImage from "../../../../assets/img/longarrow.jpg";

const AddCompanySettingsDrawer = ({ isOpen, onClose, onCreate }) => {
  const [formData, setFormData] = useState({
    company_name: "",
    vat_number: "",
    vat_percent: "",
    base_cost_per_delivery: "", // <--- new field
    postal_address: "",
    business_address: "",
    phone: "",
    email: "",
    currency: "BWP",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = () => {
    onCreate({
      ...formData,
      vat_percent: Number(formData.vat_percent),
      base_cost_per_delivery: Number(formData.base_cost_per_delivery), // <--- ensure number
    });
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerImage={headerImage}
      headerContent={<h2>Add Company Settings</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Company Name"
            name="company_name"
            value={formData.company_name}
            onChange={handleChange}
            placeholder="Enter company name"
          />

          <ReusableInput
            label="VAT Number"
            name="vat_number"
            value={formData.vat_number}
            onChange={handleChange}
            placeholder="Enter VAT number"
          />

          <ReusableInput
            label="VAT Percentage"
            name="vat_percent"
            type="number"
            value={formData.vat_percent}
            onChange={handleChange}
            placeholder="Enter VAT percentage"
          />

          <ReusableInput
            label="Base Cost Per Delivery"
            name="base_cost_per_delivery"
            type="number"
            value={formData.base_cost_per_delivery}
            onChange={handleChange}
            placeholder="Enter base cost per delivery"
          />

          <ReusableInput
            label="Postal Address"
            name="postal_address"
            value={formData.postal_address}
            onChange={handleChange}
            placeholder="Enter postal address"
          />

          <ReusableInput
            label="Business Address"
            name="business_address"
            value={formData.business_address}
            onChange={handleChange}
            placeholder="Enter business address"
          />

          <ReusableInput
            label="Phone Number"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Enter phone number"
          />

          <ReusableInput
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter email address"
          />

          <ReusableInput
            label="Currency"
            name="currency"
            value={formData.currency}
            onChange={handleChange}
            placeholder="e.g. BWP"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton
            onClick={onClose}
            fontSize="15px"
            width="100px"
            height="40px"
          >
            Cancel
          </GradientButton>

          <GradientButton
            onClick={handleSubmit}
            fontSize="15px"
            width="100px"
            height="40px"
          >
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default AddCompanySettingsDrawer;
